import { MeshBasicMaterial, Mesh, PlaneGeometry, Color } from "three";
import { VBase } from "./VBase";
import VUtil from "../VUtils";
import { Line2 } from "three/examples/jsm/lines/Line2.js";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js";

const defaultOptions = {
  map: null,
  color: 0xffffff,
  opacity: 1.0,
  texts: ["背包", "技能", "属性"],
  btnColor: 0x00ffff,
  btnOpacity: 1.0,
  textSize: 0.05,
  textColor: 0x000000,
  selectColor: 0xffff00,
  width: 1,
  height: 0.2,
  spacing: 0.02,
  gap: 0.02,
  axis: "horizongtal",
  radius: 0.02,
  font: "normal",
  defaultIndex: 0,
  disabledColor: 0xc8c8c8,
  enabledCb: null,
};

/* 
  使用案例

      const tabControl = this.uiLib.createTabControl2({
        texts: ["C++", "C#", "JAVA", "JS"],
        btnColor: 0x52587a,
      });
      // 增加光标进入元素事件，设置后会覆盖默认的光标进入事件，可选
      tabControl.addOnElementHoverEnterEvent((obj) => {
        // 不建议在这里修改颜色，会覆盖选中项
        obj.scale.set(1.1, 1.1, 1.1);
      });
      // 增加光标离开元素事件，设置后会覆盖默认的光标离开事件，可选
      tabControl.addOnElementHoverExitEvent((obj) => {
        obj.scale.set(1, 1, 1);
      });
      // 增加点击事件
      tabControl.addOnElementClickEvent((obj, index) => {
        console.log("当前选中分页：", obj, " 索引为：" + index);
      });
      this.uiLib.addUIToScene(tabControl);

*/

export class VTabControl_Text extends VBase {
  /**
   * 创建单选的按钮组,纯文字，用于分页控制，如["背包","技能","属性"]等
   * options:
   * {
   *      priority: 优先级，默认为1，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99999
   *      map: 背景贴图，不是贴图地址，默认为null
   *      color: 背景颜色。默认为 0xffffff
   *      opacity: 1,按钮背景透明度，默认为1，不透明
   *      texts: 按钮文字内容，数组，默认为 ["背包","技能","属性"]
   *      btnColor: 分页按钮颜色，默认为 0x00ffff
   *      btnOpacity: 分页按钮透明度，默认为1.0，不透明
   *      textSize: 分页按钮文字大小，默认为 0.05
   *      textColor: 分页按钮文字颜色，默认为 0x000000
   *      selectColor: 当前选中的分页按钮颜色，默认为 0xffff00
   *      width: 按钮组宽度，默认为 1
   *      height: 按钮组高度，默认为 0.2
   *      spacing: 上下左右间隙，默认为0.02
   *      gap: 按钮之间的间隙，默认为0.02
   *      radius: 圆角半径，设为0则是矩形，默认为0.01
   *      axis: 按钮组排列方式，"horizongtal"-水平排列  "verticle"-垂直排列，默认为"horizongtal"
   *      font: 字体正常或粗体，"normal"-正常  "bold"-粗体 ，默认为"normal"
   *      defaultIndex: 默认选中的分页按钮索引，默认为0
   *      disabledColor:  ui对象禁用颜色，默认为 0xC8C8C8
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 1,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99999,
      map: options.map ? options.map : defaultOptions.map,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      texts: options.texts ? options.texts : defaultOptions.texts,
      btnColor:
        options.btnColor !== undefined
          ? options.btnColor
          : defaultOptions.btnColor,
      btnOpacity:
        options.btnOpacity !== undefined
          ? options.btnOpacity
          : defaultOptions.btnOpacity,
      textSize:
        options.textSize !== undefined
          ? options.textSize
          : defaultOptions.textSize,
      textColor:
        options.textColor !== undefined
          ? options.textColor
          : defaultOptions.textColor,
      selectColor:
        options.selectColor !== undefined
          ? options.selectColor
          : defaultOptions.selectColor,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      spacing:
        options.spacing !== undefined
          ? options.spacing
          : defaultOptions.spacing,
      gap: options.gap !== undefined ? options.gap : defaultOptions.gap,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
      axis: options.axis ? options.axis : defaultOptions.axis,
      font: options.font ? options.font : defaultOptions.font,
      defaultIndex:
        options.defaultIndex !== undefined
          ? options.defaultIndex
          : defaultOptions.defaultIndex,
      disabledColor:
        options.disabledColor !== undefined
          ? options.disabledColor
          : defaultOptions.disabledColor,
    };
    if (tempOptions.opacity <= 0) tempOptions.opacity = 0.01;

    if (!tempOptions.texts || tempOptions.texts.length <= 0) {
      console.warn(
        "VTabControl error: 请输入正确的分页名称, 如['背包','技能','属性']"
      );
      tempOptions.texts = ["背包", "技能", "属性"];
    }

    const offset =
      (tempOptions.texts.length - 1) * tempOptions.gap +
      tempOptions.spacing * 2;
    if (tempOptions.axis === "verticle") {
      if (offset >= tempOptions.height) {
        console.warn(
          "VTabControl error: 分页边缘间隙(spacing)和按钮间隙(gap)设置错误"
        );
        tempOptions.gap = 0;
        tempOptions.spacing = 0;
      }
    } else {
      tempOptions.axis = "horizontal";
      if (offset >= tempOptions.width) {
        console.warn(
          "VTabControl error: 分页边缘间隙(spacing)和按钮间隙(gap)设置错误"
        );
        tempOptions.gap = 0;
        tempOptions.spacing = 0;
      }
    }
    if (tempOptions.defaultIndex < 0) tempOptions.defaultIndex = 0;
    if (tempOptions.defaultIndex >= tempOptions.texts.length)
      tempOptions.defaultIndex = tempOptions.texts.length - 1;

    super(tempOptions, vuiLib);
    this._vType = "VTabControl";

    this._otherProps = {
      texts: tempOptions.texts,
      btnOpacity: tempOptions.btnOpacity,
      btnColor: tempOptions.btnColor,
      selectColor: tempOptions.selectColor,
      spacing: tempOptions.spacing,
      gap: tempOptions.gap,
      axis: tempOptions.axis,
      defaultIndex: tempOptions.defaultIndex,
      onElementHoverEnter: [],
      onElementHoverExit: [],
      onElementClick: [],
    };

    this.normalColor = new Color(this._otherProps.btnColor);
    //this.normalColor.convertSRGBToLinear();
    this.selectColor = new Color(this._otherProps.selectColor);
    //this.selectColor.convertSRGBToLinear();

    this.currentIndex = this._otherProps.defaultIndex;

    if (this._baseProps.opacity <= 0.01) this.material.visible = false;

    this.name = "VTabControl";

    this.btns = [];
    let btnWidht = 0;
    let btnHeight = 0;
    if (this._otherProps.axis === "horizontal") {
      btnWidht =
        (this._baseProps.width -
          this._otherProps.spacing * 2 -
          (this._otherProps.texts.length - 1) * this._otherProps.gap) /
        this._otherProps.texts.length;
      btnHeight = this._baseProps.height - this._otherProps.spacing * 2;
    } else {
      btnWidht = this._baseProps.width - this._otherProps.spacing * 2;
      btnHeight =
        (this._baseProps.height -
          this._otherProps.spacing * 2 -
          (this._otherProps.texts.length - 1) * this._otherProps.gap) /
        this._otherProps.texts.length;
    }
    for (var i = 0; i < this._otherProps.texts.length; i++) {
      let geo1 = VUtil.createRectangleGeometry(
        btnWidht,
        btnHeight,
        this._baseProps.radius
      );
      let mat1 = new MeshBasicMaterial({
        color:
          this._otherProps.defaultIndex === i
            ? this._otherProps.selectColor
            : this._otherProps.btnColor,
        transparent: true,
        opacity: this._otherProps.btnOpacity,
        depthTest: this.depthTest,
      });
      VUtil.convertSRGBToLinear(mat1);
      const btn = new Mesh(geo1, mat1);
      btn.name = this._otherProps.texts[i];
      btn.renderOrder = this._baseProps.renderOrder;
      btn._vTabIndex = i;
      btn.onEcsyHoverEnter = (target) => {
        this._onElementHoverEnter(target);
      };
      // 注册光标退出事件
      btn.onEcsyHoverExit = (target) => {
        this._onElementHoverExit(target);
      };
      // 注册点击事件
      btn.onVRClick = (obj) => {
        this._onClickBtn(obj);
      };

      // 文字
      const text = VUtil.createText(
        this._otherProps.axis === "horizontal"
          ? this._otherProps.texts[i]
          : this._textSplice(this._otherProps.texts[i]),
        this._textProps.textSize,
        this._textProps.textColor,
        this._textProps.font
      );

      text.renderOrder = this._baseProps.renderOrder;
      btn.add(text);

      this.add(btn);
      this.btns.push(btn);
      if (this._otherProps.axis === "horizontal") {
        btn.position.x =
          -this._baseProps.width / 2 +
          this._otherProps.spacing +
          btnWidht / 2 +
          i * (btnWidht + this._otherProps.gap);
      } else {
        btn.position.y =
          this._baseProps.height / 2 -
          this._otherProps.spacing -
          btnHeight / 2 -
          i * (btnHeight + this._otherProps.gap);
      }
      btn.position.z += 0.001;
    }

    if (this.vuilib) {
      for (var j = 0; j < this.btns.length; j++) {
        this.vuilib.addComponents(this.btns[j], this._priority - 1);
      }
    }

    this.width = this._baseProps.width;
    this.height = this._baseProps.height;

    this.border = this._createBorder(btnWidht, btnHeight);
    this.add(this.border);
    this.border.visible = false;
  }

  /**
   * 垂直排列时将文字按 \n 拆分成单个
   */
  _textSplice(text) {
    const result = text.split("").join("\n");
    return result;
  }

  _onElementHoverEnter(target) {
    if (!this._baseProps.enabled) return;
    if (this._otherProps.onElementHoverEnter.length > 0) {
      for (var i = 0; i < this._otherProps.onElementHoverEnter.length; i++) {
        this._otherProps.onElementHoverEnter[i](target);
      }
    } else if (this.border) {
      this.border.visible = true;

      this.border.position.copy(target.position);
      this.border.position.z += 0.001;
    }
  }

  _onElementHoverExit(target) {
    if (!this._baseProps.enabled) return;
    if (this._otherProps.onElementHoverExit.length > 0) {
      for (var i = 0; i < this._otherProps.onElementHoverExit.length; i++) {
        this._otherProps.onElementHoverExit[i](target);
      }
    } else if (this.border) this.border.visible = false;
  }

  _onClickBtn(obj) {
    if (!this._baseProps.enabled) return;
    if (this.currentIndex === obj._vTabIndex) {
      return;
    }
    this.btns[this.currentIndex].material.color = this.normalColor;

    this.currentIndex = obj._vTabIndex;
    this.btns[this.currentIndex].material.color = this.selectColor;

    for (var i = 0; i < this._otherProps.onElementClick.length; i++) {
      this._otherProps.onElementClick[i](obj, this.currentIndex);
    }
  }

  _createBorder(width, height) {
    let points = [
      -width / 2,
      height / 2,
      0,

      width / 2,
      height / 2,
      0,

      width / 2,
      -height / 2,
      0,

      -width / 2,
      -height / 2,
      0,

      -width / 2,
      height / 2,
      0,
    ];

    let color = new Color(0xff6d33);
    let colors = [
      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,
    ];

    const geometry = new LineGeometry();
    geometry.setPositions(points);
    geometry.setColors(colors);
    const matLine = new LineMaterial({
      color: 0xffffff,
      linewidth: 0.002, // in world units with size attenuation, pixels otherwise
      vertexColors: true,
      dashed: false,
      alphaToCoverage: true,
      transparent: true,
    });

    const line = new Line2(geometry, matLine);
    //line.computeLineDistances();
    line.renderOrder = this._baseProps.renderOrder + 1;
    return line;
  }

  _clearBorder() {
    if (this.border) {
      this.border.geometry.dispose();
      this.border.material.dispose();
      this.border.removeFromParent();
      this.border = null;
    }
  }

  getClickable() {
    if (!this.visible || !this._baseProps.enabled) return [];
    return this.btns;
  }

  /**
   * 增加一个 光标进入元素事件回调，回调参数为当前进入的元素对象
   * @param {*} value
   */
  addOnElementHoverEnterEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementHoverEnter.push(fun);
  }

  /**
   * 移除一个 光标进入元素事件回调
   * @param {*} fun
   */
  removeOnElementHoverEnterEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementHoverEnter.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementHoverEnter.splice(index, 1);
    }
  }

  /**
   * 移除所有 光标进入元素事件回调
   */
  removeAllOnElementHoverEnterEvent() {
    this._otherProps.onElementHoverEnter = [];
  }

  /**
   * 增加一个 光标离开元素事件回调，回调参数为当前离开的元素对象
   * @param {*} fun
   */
  addOnElementHoverExitEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementHoverExit.push(fun);
  }

  /**
   * 移除一个 光标离开元素事件回调
   * @param {*} fun
   */
  removeOnElementHoverExitEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementHoverExit.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementHoverExit.splice(index, 1);
    }
  }

  /**
   * 移除所有 光标离开元素事件回调
   */
  removeAllOnElementHoverExitEvent() {
    this._otherProps.onElementHoverExit = [];
  }

  /**
   * 增加一个 元素点击事件回调，回调参数为当前点击的元素对象和索引
   * @param {*} fun
   * @returns
   */
  addOnElementClickEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementClick.push(fun);
  }

  /**
   * 移除一个 元素点击事件回调
   * @param {*} fun
   */
  removeOnElementClickEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementClick.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementClick.splice(index, 1);
    }
  }

  /**
   * 移除所有 元素点击事件回调
   */
  removeAllOnElementClickEvent() {
    this._otherProps.onElementClick = [];
  }
}
